// extracted by mini-css-extract-plugin
export default {"scope":"_6zvXB","textarea":"fMkJI"};